import React from "react";
import { AlertTriangle } from "lucide-react";
import { useBalance } from "@/lib/balance-context";

/**
 * Slim, always-visible ribbon shown when the authenticated user is a demo account.
 * Reads `is_demo` from the balance context (populated by GET /api/billing/balance).
 * Non-dismissible by design — the customer we're demoing to should always see the
 * "no real charges, no real emails" reassurance while the sales conversation is live.
 */
export const DemoBanner = () => {
  const { balance } = useBalance();
  if (!balance?.is_demo) return null;

  return (
    <div
      data-testid="demo-mode-banner"
      className="w-full bg-terracotta text-vault-950 border-b border-black/20"
      role="status"
      aria-live="polite"
    >
      <div className="max-w-6xl mx-auto px-4 md:px-8 py-2 flex items-center gap-3 text-xs sm:text-sm">
        <AlertTriangle className="w-4 h-4 flex-shrink-0" strokeWidth={2} />
        <p className="font-medium leading-tight">
          <span className="label-mono uppercase tracking-wider mr-2">Demo Mode</span>
          <span className="opacity-90">
            You are in Demo Mode — no real charges, no real emails outside the allowlist.
          </span>
        </p>
      </div>
    </div>
  );
};

export default DemoBanner;
